import { Component, Input, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-shortdate',
  templateUrl: './shortdate.component.html',
  styleUrls: ['./shortdate.component.css']
})
export class ShortdateComponent implements OnInit, OnChanges {
  dateformat:string;
  @Input() date:Date;
  constructor() { }

  ngOnInit(): void {
    this.parsedate(new Date(this.date));
  }
  ngOnChanges(changes:SimpleChanges){
    if(changes.date && changes.date.currentValue){
      this.parsedate(new Date(this.date));
    }
    
  }
  parsedate(date:Date){
    let now = new Date();
    let datedate = date.getDate();
    let nowdate = now.getDate();
    let dateyear = date.getFullYear();
    let nowyear = now.getFullYear();
    //If date is today - within same day as now
    if(datedate == nowdate){
      this.dateformat = 'today';
    }
    if(datedate != nowdate && dateyear == nowyear){
      this.dateformat = "currentyear";
    }
    if(dateyear != nowyear){
      this.dateformat = "pastyear";
    
    }
    //console.log(this.dateformat);
  }


}
